import { dissocPath } from 'ramda';
import { StateType } from 'store/store.types';

export const removeRollbackInfo = (transactionId: string) => (
  state: StateType,
): StateType => dissocPath(['optimisticTransactions', transactionId], state);
